<template>
    <div  class="home-banner">
        <el-carousel :height="imgHeight" :interval="5000" arrow="hover">
            <el-carousel-item v-for="(item) in recommend" :key="item.id">
                <div class="banner-box p-pointer" @click="$router.push({path:'/home/lessons/study',query:{id:item.id,title:item.name}})">
                    <el-image ref="img" :src="item.image" alt="" @load="getImgHeight" @click="$router.push({path:'/lessons',query:{id:item.id,title:item.name}})"/>
                    <div class="banner-me">
                        <div class="banner-me-box">
                            <div class="synopsis">
                                <h3 class="omit">{{item.name}}</h3>
                                <p>講師：{{getLecturers(item)}}</p>
                                <p>學習時間：{{`${getTime(item.study_begin_date)}至${getTime(item.study_of_date)}`}}</p>
                                <p class="omit">描述：{{item.description}}</p>
                            </div>
                            <div class="more" @click="(e)=>goPageMore(e,item)">
                                <span>更多</span>
                                <i class="el-icon-d-arrow-right"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
import { formatDateTime } from '@/utils';
export default {
    data(){
        return {
            imgHeight:"271px",
            recommend:[]
        }
    },
    created(){
        const { getHotCourse }=this.$store.state.home.homeKeep;  //保存首页数据
        if(getHotCourse){
            this.recommend=getHotCourse
        }else{
            this.getHotCourse();
        }
        // this.getHotCourse();
    },
    mounted(){
        
    },
    methods:{
        // 推荐
        async getHotCourse(){
            const navImg=[
                require('@p/assets/images/Banner1.png'),
                require('@p/assets/images/Banner2.png'),
                require('@p/assets/images/Banner3.png'),
                require('@p/assets/images/Banner4.png'),
                require('@p/assets/images/Banner5.png'),
                require('@p/assets/images/Banner6.png'),
            ];
            await this.$http.home.getHotCourse({params:{page:1,take:6}}).then(v=>{
                if(v.status === 200){
                    v.data.data.data.forEach(item =>{
                        if(item.required === 0 && this.recommend.length<6){
                            this.recommend.push({...item,image:navImg[this.recommend.length]})
                        }
                    })
                    this.$store.commit('setHomeKeep',{'getHotCourse':this.recommend});
                }
            }).catch(v=>{})
        },
        goPageMore(e,item){
            e.stopPropagation();
            this.$router.push({path:'/hotCourseMore',query:{id:item.id, title:'最新課程推薦'}})
        },
        getTime(v){
            return formatDateTime(v,'yyyy-MM-dd HH:mm')
        },
        getImgHeight(){
        //    this.imgHeight=this.$refs.img[0].$el.offsetHeight+'px';
        },
         getLecturers(data){
            let par = [];
            data.lessons[0].lecturers.forEach(item=>{
                par.push(item.name_en_long)
            })
            return par.join();
         }
    }
}
</script>

<style scoped>
.el-carousel /deep/ .el-carousel__arrow--left{
    left: 6%;
    /* top: 70%; */
}
.el-carousel /deep/ .el-carousel__arrow--right{
    right: 6%;
    /* top: 70%; */
}
.el-carousel /deep/ .el-image .el-image__inner{
    position: absolute;
    width: auto;
    bottom: 0;
    height: 100%;
} 
</style>

<style lang="less" scoped>
@sectionCon:1200px;
.home-banner{
    margin-top: 69px;
    position: relative;
    .banner-box{
        height: 270px;
        overflow: hidden;
        position: relative;
    }
    .el-image{
        width: 100%;
        height: 100%;
    }
    .banner-me{
        position:absolute;
        top: 0;
        color: #ffffff;
        width: 100%;
        height: 100%;
        .banner-me-box{
            width: 1200px;
            margin: 0 auto;
            position: relative;
            height: 100%;
            .synopsis{
                width: 540px;
                margin-left: 70px;
                padding-top: 56px;
                box-sizing: border-box;
                h3{
                    font-size: 32px;
                    padding-bottom: 6px;
                    font-weight: 400;
                }
                p{
                    font-size: 14px;
                    margin-top: 10px;
                }
            }
            .more{
                position: absolute;
                right: 0;
                bottom: 18px;
                width:88px;
                height:40px;
                line-height: 40px;
                text-align: center;
                background:rgba(255,255,255,0.1);
                border:1px solid rgba(255,255,255,0.30196078431372547);
                border-radius:28px;
                font-size: 16px;
            }
        }
    }
}
</style>
